"use strict"

class TLawPostFeed {

  constructPostFromJson(post_data, hidden) { 
    /*
    <div class="tlaw-post-feed-post">
      <div class="tlaw-post-feed-title-section">
        <span class="tlaw-post-feed-title"><?php echo get_the_title($post); ?></span>
      </div>
      <div class="tlaw-post-feed-post-body-section">
        <p class="tlaw-post-feed-post-body">
          <?php echo get_the_excerpt($post) ?>
        </p>
      </div>
    </div>
    */

    const postItem = document.createElement("div");
    postItem.classList
      .add("post-feed-block__item");
    postItem.classList
      .add('tlaw-post-feed-post-item');

    const postRoot = document.createElement("article");
    postRoot.classList
      .add("tlaw-post-feed-post");
    postRoot.classList
      .add('post-feed-block__post');
    postRoot.setAttribute("data-time", post_data.date);

    //Title
    const postTitleSection = document.createElement("div");
    postTitleSection.classList
      .add("tlaw-post-feed-title-section");
    postTitleSection.classList
      .add("post__title");

    const postTitleText = document.createElement("span");
    postTitleText.classList
      .add("tlaw-post-feed-title");
    if(post_data.title) {
      postTitleText.innerHTML = post_data.title.rendered;
    }
    if(post_data.author_name) {
      postTitleText.innerHTML = "Message From " + post_data.author_name;
    }
    postTitleSection.appendChild(postTitleText);

    //Body
    const postBodySection = document.createElement("div");
    postBodySection.classList
      .add("tlaw-post-feed-post-body-section");
    postBodySection.classList
      .add("post__body");

    //Body content
    const postBodyText = document.createElement("div");
    postBodyText.classList
      .add("tlaw-post-feed-post-body");
    postBodyText.classList
      .add('post__body__content');
    if (this.content_display === "full") {
      postBodyText.innerHTML = post_data.content.rendered;
    }
    else if (this.content_display === "excerpt") {
      postBodyText.innerHTML = post_data.excerpt.rendered;
    }

    postBodySection.appendChild(postBodyText);


    //Add to node
    postRoot.appendChild(postTitleSection);
    postRoot.appendChild(postBodySection);

    postItem.appendChild(postRoot);

    return postItem;
  }

  addDateFields(data, type, date_time) {

    if (type === "getOlderPosts") {
      if (this.query_type !== "comments") {
        data["_fields"] = "title,date," + (this.content_display === "excerpt" ? "excerpt" : "content");
      }
      
      data["before"] = date_time;
    }
    else if (type==="getNewerPosts") {
      if (this.query_type !== "comments") {
        data["_fields"] = "title,date," + (this.content_display === "excerpt" ? "excerpt" : "content");
      }
      
      data["after"] = date_time;
    }
    else if (type === "pingForNewerPosts") {
      if (this.query_type !== "comments") {
        data["_fields"] = "id";
      }
      
      data["after"] = date_time;
    }

    return data;
  }

  async queryServerForComments(date_time, type) {

    let data = {
      post : this.post_id,
      per_page : this.posts_per_query,
    };

    data = this.addDateFields(data, type, date_time);

    let url = `${WP_AJAX.WP_COMMENTS_ENDPOINT}?`;
    for (var key of Object.keys(data)) {
      if (data[key]) {
        url += `${key}=${data[key]}&`;
      }
    }

    const response = await fetch(url);
    const response_json = await response.json();
    console.log(response_json);
    return response_json;
  }

  async queryServerForPosts(date_time, type) {

    let data = {
      status : "publish",
      per_page : this.posts_per_query,
      tags: this.post_tag,
      categories : this.post_category,
      relation: this.query_type,
      _fields : "title,date," + (this.content_display === "excerpt" ? "excerpt" : "content")
    };

    data = this.addDateFields(data, type, date_time);

    let url = `${WP_AJAX.WP_JSON_ENDPOINT}?`;
    for (var key of Object.keys(data)) {
      if (data[key]) {
        url += `${key}=${data[key]}&`;
      }
    }

    const response = await fetch(url);
    const response_json = await response.json();

    return response_json;
  }

  async loadPostsFromServer(type) {
    //Get the container for all the posts
    const posts = this.root.querySelectorAll(".tlaw-post-feed-post");
    let post_time;

    if (posts) {
      if (type === "getOlderPosts") {
        const last_post = posts[posts.length- 1];
        //Get the date-time of the most recent post
        post_time = last_post.getAttribute("data-time");
      }
      else if ( type === "getNewerPosts" || type === "pingForNewerPosts") {
        const newest_post = posts[0];
        post_time = newest_post.getAttribute("data-time");
      }

      post_time = post_time.replace(/-/g, "/").replace('T', ' ');

      console.log(post_time)

      const date_time = new Date(post_time).toISOString();

      if(this.query_type === "comments") {
        return await this.queryServerForComments(date_time, type);
      }
      else {
        return await this.queryServerForPost(date_time, type);
      }
    }
  }

  addPostToDOM(post, type) {
    const postsGrid = this.root.querySelector(".tlaw-post-feed-posts");
    //Construct post from data
    const newPostDiv = this.constructPostFromJson(post, false);

    if (type === "newerPost") {
      //Add it to the start of the DOM
      postsGrid.insertBefore(newPostDiv, postsGrid.firstChild);
      this.msnry.prepended(newPostDiv);
    }
    else if (type === "olderPost") {
      //Add it to the end of the DOM
      postsGrid.appendChild(newPostDiv);
      this.msnry.appended(newPostDiv);
    }
  }

  async getOlderPosts() {
    const response = await this.loadPostsFromServer("getOlderPosts");
    if (response.length > 0) {
      //add up last 4 posts to DOM
      for (var i = 0; i < response.length && i < this.posts_per_query; i++) {
        this.addPostToDOM(response[i], "olderPost");
      }
    }
    if (response.length < this.posts_per_query) {
      //Get older posts button
      const get_more_posts_button = this.root.querySelector(".tlaw-post-feed-more-posts-button");
      //Remove older posts button
      get_more_posts_button.classList.add("hidden");
    }
  }

  async getNewerPosts() {
    //hide button
    const get_new_posts_div = this.root.querySelector(".tlaw-post-feed-new-posts");
    get_new_posts_div.classList.add("hidden");


    const posts = await this.loadPostsFromServer("getNewerPosts");
    //add each post to DOM
    for (const post of Array.from(posts)) {
      this.addPostToDOM(post, "newerPost");
    }
    //set interval
    //Start pinging the server for new posts again
    this.interval_id = setInterval(this.pingForNewerPosts.bind(this), this.interval);
  }

  async pingForNewerPosts() {
    const response = await this.loadPostsFromServer("pingForNewerPosts");
    if (response.length > 0) {
      //Unhide get new posts button
      const get_new_posts_div = this.root.querySelector(".tlaw-post-feed-new-posts");
      get_new_posts_div.classList.remove("hidden");

      //clear interval (stop pinging server)
      clearInterval(this.interval_id);
    }
  }

  attachInterval() {
    const get_new_posts_button = this.root.querySelector(".tlaw-post-feed-new-posts-button");

    if (get_new_posts_button) {
      get_new_posts_button.addEventListener("click", this.getNewerPosts.bind(this));

      this.post_tag = get_new_posts_button.getAttribute("data-tag");
      this.post_category = get_new_posts_button.getAttribute("data-category");
      this.query_type = get_new_posts_button.getAttribute("data-relation");
      this.interval = get_new_posts_button.getAttribute("data-interval");
      this.post_id = get_new_posts_button.getAttribute("data-post-id");

      this.interval_id = setInterval(this.pingForNewerPosts.bind(this), this.interval);
    }
  }

  attachLoadMorePosts() {
    const get_more_posts_button = this.root.querySelector(".tlaw-post-feed-more-posts-button");
    if (get_more_posts_button) {
      get_more_posts_button.onclick = this.getOlderPosts.bind(this);
    }
  }

  constructor(div) {
    this.root;
    this.interval;
    this.post_tag;
    this.post_category;
    this.query_type;
    this.content_display;
    this.interval_id;
    this.posts_per_query = 6;
    this.root = div;
    this.content_display = this.root.getAttribute("data-content-display");
    this.msnry = new Masonry(this.root.querySelector(".tlaw-post-feed-posts"), {
      "itemSelector": ".post-feed-block__item",
      "gutter": 0,
      "horizontalOrder": false,
      "columnWidth": ".grid-sizer"
    });

    this.root.classList.add('loaded');

    this.attachInterval();
    this.attachLoadMorePosts();
  }
}

function TLawPostFeedInit() {
  const postFeeds = document.getElementsByClassName("tlaw-post-feed");
  if (postFeeds) {
    for (let postFeed of Array.from(postFeeds)) {
      new TLawPostFeed(postFeed);
    }
  }
}

window.addEventListener('load', TLawPostFeedInit);
